import { observer } from "mobx-react";
import classNames from "classnames";
import css from "./appBar.module.scss";
import {
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import i18next from "i18next";
import { useState } from "react";
import logo from "src/assets/logo.png";
import ic_th from "src/assets/icons/ic_th.png";
import ic_uk from "src/assets/icons/ic_uk.png";
import ic_la from "src/assets/icons/ic_la.png";
import { Logout, Settings } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface AppBarProps {
  children: string;
  showUser: boolean;
  showLang: boolean;
}

const AppBar = ({
  children = "",
  showUser = false,
  showLang = false,
}: AppBarProps) => {
  const navigate = useNavigate();

  const [anchorLang, setAnchorLang] = useState(null);
  const [anchorUser, setAnchorUser] = useState(null);
  const open = Boolean(anchorLang);

  const onChangeLanguage = (lang) => {
    i18next.changeLanguage(lang, (err) => {
      if (!err) {
        setAnchorLang(null);
      }
    });
  };
  const handleLangClick = (event) => {
    setAnchorLang(event.currentTarget);
  };
  const handleLangClose = () => {
    setAnchorLang(null);
  };
  const getIconLang = (lang) => {
    switch (lang) {
      case "th":
        return ic_th;
      case "en":
        return ic_uk;
      case "la":
        return ic_la;
      default:
        return ic_th;
    }
  };
  const menuLang = (lang) => {
    return (
      <MenuItem
        onClick={() => onChangeLanguage(lang)}
        style={{ padding: "12px 16px" }}
      >
        <img
          src={getIconLang(lang)}
          alt="icon"
          style={{ width: "24px", marginRight: "12px" }}
        />
        {getFullLang(lang)}
      </MenuItem>
    );
  };
  const getFullLang = (lang) => {
    switch (lang) {
      case "th":
        return "ไทย";
      case "en":
        return "English";
      case "la":
        return "ລາວ";
    }
  };

  const handleUserClick = (event) => {
    setAnchorUser(event.currentTarget);
  };
  const handleUserClose = () => {
    setAnchorUser(null);
  };
  const onclickLogout = () => {
    navigate("/login");
  };

  return (
    <Box className={css.appBar}>
      <Box className={css.container}>
        <Box className={css.left}>
          <img src={logo} alt="logo" className={css.logo} />
        </Box>
        <Box className={css.title}>{children}</Box>
        <Box className={css.right}>
          {showLang && (
            <div>
              <Button
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleLangClick}
                className={classNames(css.btnLang)}
              >
                <img
                  src={getIconLang(i18next.language)}
                  alt="icon"
                  className={css.icon}
                />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorLang}
                open={open}
                onClose={handleLangClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {menuLang("th")}
                {menuLang("en")}
              </Menu>
            </div>
          )}
          {showUser && (
            <div>
              <Tooltip title="Account settings">
                <IconButton
                  onClick={handleUserClick}
                  size="small"
                  sx={{ ml: 2 }}
                  aria-controls={anchorUser ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={anchorUser ? "true" : undefined}
                >
                  <Avatar sx={{ width: 32, height: 32 }}>IM</Avatar>
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorUser}
                id="account-menu"
                open={anchorUser}
                onClose={handleUserClose}
                onClick={handleUserClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem style={{ minWidth: "180px" }}>
                  <Avatar /> Immigration
                </MenuItem>
                <Divider />
                {/* <MenuItem>
                  <ListItemIcon>
                    <Settings fontSize="small" />
                  </ListItemIcon>
                  Settings
                </MenuItem> */}
                <MenuItem onClick={onclickLogout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </div>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default observer(AppBar);
